import { type MutationError, trpc } from '@/shared/api';

interface Options {
  readonly onSuccess?: () => void;
}

/** 상품의 현재 편집영역·실측·허용 목록으로 템플릿을 만든다. */
export const useCreateTemplateFromProduct = ({ onSuccess }: Options = {}) => {
  const mutation = trpc.productManagement.editAreaTemplates.createFromProduct.useMutation({
    onSuccess,
  });
  const error: MutationError | null = mutation.error;

  return { createFromProduct: mutation.mutate, isPending: mutation.isPending, error };
};
